module.exports = "https://web-assets.ifttt.com/packs/media/onboarding/selector_helper@3x-a1e346c8.png";